import React from 'react'
import { AccountRegisterContainer } from '../../../components/AccountRegisterContainer'
import { routesDef } from '../../../config/routes'
import { BasicAuthLayout } from './BasicAuthLayout'
import { PasswordlessAuthLayout } from './PasswordlessAuthLayout'
import { Stack } from 'react-bootstrap'
import { Link, ShowIf } from '@ztechapps/webui.util'
import { Link as RouterLink } from 'react-router-dom'
import { GoogleAuthLayout } from './GoogleAuthLayout'

enum LoginMethod {
  PASSWORDLESS = 'passwordless',
  BASIC = 'basic',
  GOOGLE_OAUTH = 'google_oauth',
}

export const Layout = () => {
  const [loginMethod, setLoginMethod] = React.useState<LoginMethod>(LoginMethod.BASIC)

  return (
    <AccountRegisterContainer>
      <Stack gap={5}>
        <ShowIf condition={loginMethod === LoginMethod.PASSWORDLESS}>
          <PasswordlessAuthLayout />
        </ShowIf>

        <ShowIf condition={loginMethod === LoginMethod.BASIC}>
          <BasicAuthLayout />
        </ShowIf>

        <div>
          <h5 className="fw-bold">Or try other login method</h5>

          <div>
            <Stack gap={1}>
              <ShowIf condition={loginMethod !== LoginMethod.BASIC}>
                <Link onClick={() => setLoginMethod(LoginMethod.BASIC)}>With UserName & Password Login</Link>
              </ShowIf>
              <ShowIf condition={loginMethod !== LoginMethod.PASSWORDLESS}>
                <Link onClick={() => setLoginMethod(LoginMethod.PASSWORDLESS)}>With Passwordless Login</Link>
              </ShowIf>
              <GoogleAuthLayout />
            </Stack>
          </div>
        </div>
      </Stack>

      <p className="text-center mt-4 mb-5">
        Do not have account? <RouterLink to={routesDef.RegisterPage.altPath}>Sign up</RouterLink>
      </p>
    </AccountRegisterContainer>
  )
}
